import React from 'react';
import { Attachment } from '@teetsh/app/src/types/attachment';
import { FolderOpenIcon as FolderOpen } from '@heroicons/react/24/outline';
import PillButton from '@teetsh/app/src/components/Buttons/PillButton';
import { AcceptOnly, useDropzone } from './useDropzone';
import { useTranslation } from 'react-i18next';

interface Props {
  onChange: (v: Attachment[]) => void;
  label?: string;
  attachments?: Attachment[];
  uploadingAttachment?: boolean;
  handleError: ({ message }: { message: string }) => void;
  handleUploadAttachment: (payload: { file: File }) => Promise<any>;
  icon?: any;
  multiple?: boolean;
  acceptOnly?: AcceptOnly;
}

export default function PillButtonAttachment(props: Props) {
  const { t } = useTranslation(['common']);
  const {
    attachments = [],
    uploadingAttachment = false,
    label = t('common:buttons.attachDocuments'),
    onChange,
    icon,
    handleUploadAttachment,
    handleError,
    multiple,
    acceptOnly,
  } = props;

  const { getRootProps, getInputProps } = useDropzone({
    handleUploadAttachment,
    handleError,
    attachments,
    onChange,
    multiple,
    acceptOnly,
  });

  const { ref, ...rest } = getRootProps();
  return (
    <PillButton
      {...rest}
      onMouseDown={(rest?.onMouseDown as any) || (() => {})}
      leftIcon={icon || FolderOpen}
      loading={uploadingAttachment}
      data-testid="attachments"
    >
      <span data-testid="attachment-area">
        <input {...(getInputProps() as any)} data-testid="attachment-input" />
        {label}
      </span>
    </PillButton>
  );
}
